var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeviceMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8225 3.5293H6.17758C5.79682 3.5293 5.48816 3.83796 5.48816 4.21871V19.7801C5.48816 20.1609 5.79682 20.4695 6.17758 20.4695H18.8225C19.2032 20.4695 19.5119 20.1609 19.5119 19.7801V4.21871C19.5119 3.83796 19.2032 3.5293 18.8225 3.5293Z",
    fill: "#575B6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4994 19.975C12.7974 19.975 13.039 19.7334 13.039 19.4354C13.039 19.1374 12.7974 18.8958 12.4994 18.8958C12.2014 18.8958 11.9598 19.1374 11.9598 19.4354C11.9598 19.7334 12.2014 19.975 12.4994 19.975Z",
    fill: "#828A9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5465 4.40234H6.45239V18.4261H18.5465V4.40234Z",
    fill: "#69B0EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63419 18.4261H7.20837L14.2501 4.40234H14.6759L7.63419 18.4261Z",
    fill: "#ABD0EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 4.40234H15.7516L8.64795 18.4261H10.7297L17.8334 4.40234Z",
    fill: "#ABD0EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceMobil);
export default __webpack_public_path__ + "static/media/ic-device-mobil.18ee4b3dbe1ca6efaeee56ae0ee6cff3.svg";
export { ForwardRef as ReactComponent };